import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useCustomHook from "./useCustomHook ";

const OrderDetailsPage = () => {
  const {
    orderData,
    products,
    userDetails,
    currentPage,
    totalPages,
    handlePageChange,
  } = useCustomHook("neworder");



  return (

    <div className="mt-16 ml-0 md:ml-16">
    <div className="mt-8 mx-auto max-w-screen-lg overflow-x-auto hidden md:block">

    <h2 className="text-3xl font-bold mb-6">All New Details</h2>
    <div className="overflow-x-auto">
    <table className="w-full bg-white border rounded-lg overflow-hidden">
        <thead className="bg-gray-800 text-white">
          <tr>
            <th className="py-2 px-4 text-left">User Details</th>
            <th className="py-2 px-4 text-left">Product Details</th>
            <th className="py-2 px-4 text-left">Order Date</th>
            <th className="py-2 px-4 text-left">Total Price</th>
            <th className="py-2 px-4 text-left">Order Status</th>

          </tr>
        </thead>
        <tbody>
          
          {orderData.map((order, index) => (
            <tr key={order._id} className="p-1 border-b-2 border-black">

              {/* user details */}
              <td className="py-2 px-4">
              {userDetails[order.user] ? (
    <>
       <p className="text-sm">
          <strong className="font-semibold">Name:</strong> {userDetails[order.user].username}
        </p>
      <div className="mb-2">
        <p className="text-sm">
          <strong className="font-semibold">Phone:</strong> {userDetails[order.user].phone}
        </p>
      </div>
      <div>
        <p className="text-sm">
          <strong className="font-semibold">Address:</strong> {userDetails[order.user].address}
        </p>
      </div>
    </>
  ) : (
    <p className="text-sm">No user details available</p>
  )}
</td>

              {/* product details */}
              <td className="py-2 px-4 flex">
                <div className="">
                  {products[index] &&
                  products[index].map((product) => (
                    <div key={product._id} className="mb-2">
                      <p className="mb-1 text-sm">
                        <strong>Name:</strong> {product.name}
                      </p>
                      {/* <img
                        src={`http://localhost:3000/${product.image}`}
                        className="w-16 h-16 md:h-10 object-cover mb-2 rounded-r-2xl"
                        alt="Product"
                      /> */}
                      {/* <p className="mb-1 text-sm">
                        <strong>Price:</strong> {product.price}
                      </p>
                      <p className="text-sm">
                        <strong>Description:</strong> {product.description}
                      </p>
                      <p className="text-sm">
                        <strong>Quantity:</strong> {product.quantity}
                      </p> */}
                    </div>
                  ))}
                </div>
                
                
              </td>

             
              {/* Order Date */}
              <td className="py-2 px-4">
                {new Date(order.order_date).toLocaleString()}
              </td>

              {/* Total price */}
              <td className="py-2 px-4">{order.price}</td>

               {/* Add Status */}
               <td className="py-2 px-4">{order.status}</td>
            <div className=" ">
              <button className="bg-amber-500 rounded p-2">
              <Link  to={`/admin/single/${order._id}`}> Go   </Link>

              </button>

            </div>
            </tr>
            
          ))}
         
        </tbody>
      </table>
    </div>
  </div>




  <div className=" md:hidden ">
 
  <div className="mt-0 grid grid-cols-1 gap-3 p-2 ">
  <ul className="flex bg-amber-300 p-1">
  <li className="p-1 text-white">
    <Link to={"/admin/home"} className="text-white">
      Home
    </Link>
  </li>
  <li className="p-1 text-white"><Link to={"/admin/orders"} className="text-white">
      Orders
    </Link></li>
</ul>




  {orderData.map((order, index) => (
    <div key={order._id} className="bg-white  border rounded-lg w-full overflow-hidden p-4 shadow-md">
      <Link to={`/admin/single/${order._id}`} className="flex">
      <div className="text-sm mt-4">
        {userDetails[order.user] ? (
          <>
            <div className="font-bold mb-3">Order Details</div>
            <p className="mb-1">
              <strong>User Name: <br /></strong> {userDetails[order.user].username}
            </p>
           
          </>
        ) : (
          <p className="mb-3">No user details available</p>
        )}
      </div>
     
      <div className="text-sm mt-4">
        <p className="mb-1">
          <strong>Status:</strong> {order.status}
        </p>
        <p className="mb-1">
          <strong>Order Date:</strong> {new Date(order.order_date).toLocaleString()}
        </p>
        <p>
          <strong>Total Price:</strong> <span className="text-red-500">Rs:{order.price}</span>
        </p>
      </div>

      {/* <div className="text-sm mt-4">
        <div className="font-bold mb-3">Product Details</div>
        {products[index] &&
          products[index].map((product) => (
            <div key={product._id} className="mb-4">
              <p className="mb-1">
                <strong>Name:</strong> {product.name}
              </p>
              <hr className="my-2" />
            </div>
          ))}
      </div> */}
      </Link>
    </div>
  ))}
</div>

  </div>

{/* Pagination */}
<div className="flex justify-center mt-4">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-4 py-2 mx-2 bg-gray-300 text-gray-700 rounded-md"
        >
          Previous
        </button>
        <span className="px-4 py-2 mx-2 bg-gray-300 text-gray-700 rounded-md">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-4 py-2 mx-2 bg-gray-300 text-gray-700 rounded-md"
        >
          Next
        </button>
      </div>

    
    </div>

  );
};

export default OrderDetailsPage;
